import apiService from './api';
import {
  Camion,
  Chauffeur,
  Produit,
  Fournisseur,
  Pesée,
  Ticket,
  CamionCreate,
  ChauffeurCreate,
  ProduitCreate,
  FournisseurCreate,
  PeséeCreate,
  TicketCreate,
  PeséeUpdate,
  ObservationRequest,
  RefusRequest,
  PeseeStatistiques,
  EnumChoice,
  ApiResponse,
  PaginatedResponse,
  Remorque,
  RemorqueCreate,
  Client,
  ClientCreate,
  Exportateur,
  Transporteur,
  TransporteurCreate,
  Fiche,
  Conditionnement
} from '../types/weighing';

class WeighingService {
  // Helper method to extract data from AxiosResponse
  private extractData<T>(response: any): ApiResponse<T> {
    
    
    const extracted = response.data;
   
    
    return extracted;
  }

  // Méthodes pour les remorques
  async getRemorques(params?: any): Promise<PaginatedResponse<Remorque>> {
    const response = await apiService.get('/weighing/api/remorques/', { params });
    return response.data;
  }

  async getRemorque(id: number): Promise<Remorque> {
    const response = await apiService.get(`/weighing/api/remorques/${id}/`);
    return response.data;
  }

  async createRemorque(data: RemorqueCreate): Promise<Remorque> {
    const response = await apiService.post('/weighing/api/remorques/', data);
    return response.data;
  }

  async updateRemorque(id: number, data: Partial<RemorqueCreate>): Promise<Remorque> {
    const response = await apiService.patch(`/weighing/api/remorques/${id}/`, data);
    return response.data;
  }

  async deleteRemorque(id: number): Promise<void> {
    const response = await apiService.delete(`/weighing/api/remorques/${id}/`);
    return response.data;
  }

  async calculerVolumeRemorque(id: number): Promise<{ volume: number }> {
    const response = await apiService.get(`/weighing/api/remorques/${id}/calculer-volume/`);
    return response.data;
  }

  // Méthodes pour les clients
  async getClients(params?: any): Promise<PaginatedResponse<Client>> {
    const response = await apiService.get('/weighing/api/clients/', { params });
    return response.data;
  }

  async getClient(id: number): Promise<Client> {
    const response = await apiService.get(`/weighing/api/clients/${id}/`);
    return response.data;
  }

  async createClient(data: ClientCreate): Promise<Client> {
    const response = await apiService.post('/weighing/api/clients/', data);
    return response.data;
  }

  async updateClient(id: number, data: Partial<ClientCreate>): Promise<Client> {
    const response = await apiService.patch(`/weighing/api/clients/${id}/`, data);
    return response.data;
  }

  async deleteClient(id: number): Promise<void> {
    const response = await apiService.delete(`/weighing/api/clients/${id}/`);
    return response.data;
  }

  // Méthodes pour les convoyeurs
  async getConvoyeurs(params?: any): Promise<PaginatedResponse<any>> {
    const response = await apiService.get('/weighing/api/convoyeurs/', { params });
    return response.data;
  }

  async getConvoyeur(id: number): Promise<any> {
    const response = await apiService.get(`/weighing/api/convoyeurs/${id}/`);
    return response.data;
  }

  async createConvoyeur(data: any): Promise<any> {
    const response = await apiService.post('/weighing/api/convoyeurs/', data);
    return response.data;
  }

  async updateConvoyeur(id: number, data: Partial<any>): Promise<any> {
    const response = await apiService.patch(`/weighing/api/convoyeurs/${id}/`, data);
    return response.data;
  }

  async deleteConvoyeur(id: number): Promise<void> {
    const response = await apiService.delete(`/weighing/api/convoyeurs/${id}/`);
    return response.data;
  }

  // Méthodes pour les magasins
  async getMagasins(params?: any): Promise<PaginatedResponse<any>> {
    const response = await apiService.get('/weighing/api/magasins/', { params });
    return response.data;
  }

  async getMagasin(id: number): Promise<any> {
    const response = await apiService.get(`/weighing/api/magasins/${id}/`);
    return response.data;
  }

  async createMagasin(data: any): Promise<any> {
    const response = await apiService.post('/weighing/api/magasins/', data);
    return response.data;
  }

  async updateMagasin(id: number, data: Partial<any>): Promise<any> {
    const response = await apiService.patch(`/weighing/api/magasins/${id}/`, data);
    return response.data;
  }

  async deleteMagasin(id: number): Promise<void> {
    const response = await apiService.delete(`/weighing/api/magasins/${id}/`);
    return response.data;
  }

  // Méthodes pour les exportateurs
  async getExportateurs(params?: any): Promise<PaginatedResponse<Exportateur>>  {
    const response = await apiService.get('/weighing/api/exportateurs/', { params });
    return response.data;
  }

  async getExportateur(id: number): Promise<Exportateur> {
    const response = await apiService.get(`/weighing/api/exportateurs/${id}/`);
    return response.data;
  }

  async createExportateur(data: any): Promise<ApiResponse<Exportateur>> {
    const response = await apiService.post('/weighing/api/exportateurs/', data);
    return this.extractData<Exportateur>(response);
  }

  async updateExportateur(id: number, data: Partial<any>): Promise<ApiResponse<Exportateur>> {
    const response = await apiService.patch(`/weighing/api/exportateurs/${id}/`, data);
    return this.extractData<Exportateur>(response);
  }

  async deleteExportateur(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.delete(`/weighing/api/exportateurs/${id}/`);
    return this.extractData<void>(response);
  }

  // Méthodes pour les transporteurs
  async getTransporteurs(params?: any): Promise<PaginatedResponse<Transporteur>> {
    const response = await apiService.get('/weighing/api/transporteurs/', { params });
    return response.data;
  }

  async getTransporteur(id: number): Promise<Transporteur> {
    const response = await apiService.get(`/weighing/api/transporteurs/${id}/`);
    return response.data;
  }

  async createTransporteur(data: TransporteurCreate): Promise<Transporteur> {
    const response = await apiService.post('/weighing/api/transporteurs/', data);
    return response.data;
  }

  async updateTransporteur(id: number, data: Partial<TransporteurCreate>): Promise<Transporteur> {
    const response = await apiService.patch(`/weighing/api/transporteurs/${id}/`, data);
    return response.data;
  }

  async deleteTransporteur(id: number): Promise<void> {
    const response = await apiService.delete(`/weighing/api/transporteurs/${id}/`);
    return response.data;
  }

  // Méthodes pour les fiches
  async getFiches(params?: any): Promise<ApiResponse<PaginatedResponse<Fiche>>> {
    const response = await apiService.get('/weighing/api/fiches/', { params });
    return this.extractData<PaginatedResponse<Fiche>>(response);
  }

  async getFiche(id: number): Promise<ApiResponse<Fiche>> {
    const response = await apiService.get(`/weighing/api/fiches/${id}/`);
    return this.extractData<Fiche>(response);
  }

  async createFiche(data: FormData): Promise<ApiResponse<Fiche>> {
    const response = await apiService.post('/weighing/api/fiches/', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return this.extractData<Fiche>(response);
  }

  async updateFiche(id: number, data: Partial<any>): Promise<ApiResponse<Fiche>> {
    const response = await apiService.patch(`/weighing/api/fiches/${id}/`, data);
    return this.extractData<Fiche>(response);
  }

  async deleteFiche(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.delete(`/weighing/api/fiches/${id}/`);
    return this.extractData<void>(response);
  }

  async telechargerFiche(id: number): Promise<ApiResponse<{ fichier_url: string }>> {
    const response = await apiService.get(`/weighing/api/fiches/${id}/telecharger/`);
    return this.extractData<{ fichier_url: string }>(response);
  }

  // Méthodes pour les camions
  async getCamions(params?: any): Promise<PaginatedResponse<Camion>> {
    const response = await apiService.get('/weighing/api/camions/', { params });
    return response.data;
  }

  async getCamion(id: number): Promise<ApiResponse<Camion>> {
    const response = await apiService.get(`/weighing/api/camions/${id}/`);
    return this.extractData<Camion>(response);
  }

  async createCamion(data: CamionCreate): Promise<ApiResponse<Camion>> {
    const response = await apiService.post('/weighing/api/camions/', data);
    return this.extractData<Camion>(response);
  }

  async updateCamion(id: number, data: Partial<CamionCreate>): Promise<ApiResponse<Camion>> {
    const response = await apiService.patch(`/weighing/api/camions/${id}/`, data);
    return this.extractData<Camion>(response);
  }

  async deleteCamion(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.delete(`/weighing/api/camions/${id}/`);
    return this.extractData<void>(response);
  }

  async calculerTareMoyenne(id: number): Promise<ApiResponse<{ tare_moyenne: number }>> {
    const response = await apiService.post(`/weighing/api/camions/${id}/calculer-tare-moyenne/`);
    return this.extractData<{ tare_moyenne: number }>(response);
  }

  async getHistoriquePesées(id: number): Promise<ApiResponse<Pesée[]>> {
    const response = await apiService.get(`/weighing/api/camions/${id}/historique-pesees/`);
    return this.extractData<Pesée[]>(response);
  }

  // Méthodes pour les chauffeurs
  async getChauffeurs(params?: any): Promise<PaginatedResponse<Chauffeur>> {
    const response = await apiService.get('/weighing/api/chauffeurs/', { params });
    return response.data;
  }

  async getChauffeur(id: number): Promise<Chauffeur> {
    const response = await apiService.get(`/weighing/api/chauffeurs/${id}/`);
    return response.data;
  }

  async createChauffeur(data: ChauffeurCreate): Promise<Chauffeur> {
    const response = await apiService.post('/weighing/api/chauffeurs/', data);
    return response.data;
  }

  async updateChauffeur(id: number, data: Partial<ChauffeurCreate>): Promise<Chauffeur> {
    const response = await apiService.patch(`/weighing/api/chauffeurs/${id}/`, data);
    return response.data;
  }

  async deleteChauffeur(id: number): Promise<void> {
    const response = await apiService.delete(`/weighing/api/chauffeurs/${id}/`);
    return response.data;
  }

  async getHistoriqueLivraisons(id: number): Promise<ApiResponse<Pesée[]>> {
    const response = await apiService.get(`/weighing/api/chauffeurs/${id}/historique-livraisons/`);
    return this.extractData<Pesée[]>(response);
  }



  // Méthodes pour les produits
  async getProduits(params?: any): Promise<PaginatedResponse<Produit>> {
    const response = await apiService.get('/weighing/api/produits/', { params });
    return response.data;
  }

  async getProduit(id: number): Promise<ApiResponse<Produit>> {
    const response = await apiService.get(`/weighing/api/produits/${id}/`);
    return this.extractData<Produit>(response);
  }

  async createProduit(data: ProduitCreate): Promise<ApiResponse<Produit>> {
    const response = await apiService.post('/weighing/api/produits/', data);
    return this.extractData<Produit>(response);
  }

  async updateProduit(id: number, data: Partial<ProduitCreate>): Promise<ApiResponse<Produit>> {
    const response = await apiService.patch(`/weighing/api/produits/${id}/`, data);
    return this.extractData<Produit>(response);
  }

  async deleteProduit(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.delete(`/weighing/api/produits/${id}/`);
    return this.extractData<void>(response);
  }

  async getTypesDisponibles(): Promise<ApiResponse<EnumChoice[]>> {
    const response = await apiService.get('/weighing/api/produits/types-disponibles/');
    return this.extractData<EnumChoice[]>(response);
  }

  // Méthodes pour les conditionnements
  async getConditionnements(params?: any): Promise<PaginatedResponse<Conditionnement>> {
    const response = await apiService.get('/weighing/api/conditionnements/', { params });
    return response.data;
  }

  async getConditionnement(id: number): Promise<ApiResponse<Conditionnement>> {
    const response = await apiService.get(`/weighing/api/conditionnements/${id}/`);
    return this.extractData<Conditionnement>(response);
  }

  async createConditionnement(data: any): Promise<ApiResponse<Conditionnement>> {
    const response = await apiService.post('/weighing/api/conditionnements/', data);
    return this.extractData<Conditionnement>(response);
  }

  async updateConditionnement(id: number, data: any): Promise<ApiResponse<Conditionnement>> {
    try {
      const response = await apiService.patch(`/weighing/api/conditionnements/${id}/`, data);
      return this.extractData<Conditionnement>(response);
    } catch (error: any) {
      console.error('Erreur détaillée updateConditionnement:', error);
      if (error.response) {
        console.error('Status:', error.response.status);
        console.error('Data:', error.response.data);
        console.error('Headers:', error.response.headers);
        
        // Afficher les erreurs de validation en détail
        if (error.response.data && error.response.data.errors) {
          console.error('Erreurs de validation détaillées:', JSON.stringify(error.response.data.errors, null, 2));
        }
      }
      throw error;
    }
  }

  async deleteConditionnement(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.delete(`/weighing/api/conditionnements/${id}/`);
    return this.extractData<void>(response);
  }

  // Méthodes pour les fournisseurs
  async getFournisseurs(params?: any): Promise<PaginatedResponse<Fournisseur>> {
    const response = await apiService.get('/weighing/api/fournisseurs/', { params });
    return response.data;
  }

  async getFournisseur(id: number): Promise<Fournisseur> {
    const response = await apiService.get(`/weighing/api/fournisseurs/${id}/`);
    return response.data;
  }

  async createFournisseur(data: FournisseurCreate): Promise<Fournisseur> {
    const response = await apiService.post('/weighing/api/fournisseurs/', data);
    return response.data;
  }

  async updateFournisseur(id: number, data: Partial<FournisseurCreate>): Promise<ApiResponse<Fournisseur>> {
    const response = await apiService.patch(`/weighing/api/fournisseurs/${id}/`, data);
    return response.data;
  }

  async deleteFournisseur(id: number): Promise<void> {
    const response = await apiService.delete(`/weighing/api/fournisseurs/${id}/`);
    return response.data;
  }



  // Méthodes pour les pesées
  async getPesées(params?: any): Promise<PaginatedResponse<Pesée>> {
    // Ajouter les paramètres pour récupérer les relations
    const enhancedParams = {
      ...params,
      include_relations: 'true', // Inclure toutes les relations
      expand: 'camion,chauffeur,produit,client,fournisseur,exportateur,analyse_qualite' // Relations à étendre
    };
    const response = await apiService.get('/weighing/api/pesees/', { params: enhancedParams });
    
   
    
    // L'API retourne directement les données dans response.data
    return response.data;
  }

  async getPesée(id: number): Promise<ApiResponse<Pesée>> {
    
    
    // Ajouter les paramètres pour récupérer les relations
    const params = {
      include_relations: 'true',
      expand: 'camion,chauffeur,produit,client,fournisseur,exportateur,analyse_qualite'
    };
    
   
    
    try {
      const response = await apiService.get(`/weighing/api/pesees/${id}/`, { params });
      
      
      const extractedData = this.extractData<Pesée>(response);
      
      
      // Vérifier si la réponse a déjà le format ApiResponse
      if (extractedData && (extractedData.success !== undefined || extractedData.data !== undefined)) {
        
        return extractedData;
      } else {
        // Wrapper la réponse dans le format ApiResponse
        return {
          success: true,
          data: extractedData as unknown as Pesée,
          message: 'Pesée récupérée avec succès'
        };
      }
    } catch (error) {
      console.error('🔧 WeighingService.getPesée: Erreur:', error);
      throw error;
    }
  }

  async createPesée(data: PeséeCreate): Promise<ApiResponse<Pesée>> {
    
    
    const response = await apiService.post('/weighing/api/pesees/', data);
    return this.extractData<Pesée>(response);
  }

  async updatePesée(id: number, data: PeséeUpdate): Promise<ApiResponse<Pesée>> {
    const response = await apiService.patch(`/weighing/api/pesees/${id}/`, data);
    return this.extractData<Pesée>(response);
  }

  async deletePesée(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.delete(`/weighing/api/pesees/${id}/`);
    return this.extractData<void>(response);
  }

  // Actions spéciales pour les pesées
  async nouvellePesée(data: PeséeCreate): Promise<ApiResponse<{ pesée: Pesée; ticket: Ticket; message: string }>> {
    const response = await apiService.post('/weighing/api/pesees/nouvelle_pesee/', data);
    return this.extractData<{ pesée: Pesée; ticket: Ticket; message: string }>(response);
  }

  async marquerComplétée(id: number): Promise<ApiResponse<Pesée>> {
    const response = await apiService.post(`/weighing/api/pesees/${id}/marquer_completee/`);
    return this.extractData<Pesée>(response);
  }

  async ajouterObservation(id: number, data: ObservationRequest): Promise<ApiResponse<Pesée>> {
    const response = await apiService.post(`/weighing/api/pesees/${id}/ajouter_observation/`, data);
    return this.extractData<Pesée>(response);
  }

  async refuserPesée(id: number, data: RefusRequest): Promise<ApiResponse<{ pesée: Pesée; ticket_refoulement: Ticket }>> {
    const response = await apiService.post(`/weighing/api/pesees/${id}/refuser_pesee/`, data);
    return this.extractData<{ pesée: Pesée; ticket_refoulement: Ticket }>(response);
  }

  async updatePesee(id: number, data: PeséeUpdate): Promise<ApiResponse<Pesée>> {
    const response = await apiService.patch(`/weighing/api/pesees/${id}/`, data);
    return this.extractData<Pesée>(response);
  }

  async getPeséesEnAttenteTare(): Promise<ApiResponse<Pesée[]>> {
    const params = {
      include_relations: 'true',
      expand: 'camion,chauffeur,produit,client,fournisseur,exportateur'
    };
    const response = await apiService.get('/weighing/api/pesees/en_attente_tare/', { params });
    return this.extractData<Pesée[]>(response);
  }

  async getPeséesEnCours(): Promise<ApiResponse<Pesée[]>> {
    const params = {
      include_relations: 'true',
      expand: 'camion,chauffeur,produit,client,fournisseur,exportateur'
    };
    const response = await apiService.get('/weighing/api/pesees/en_cours/', { params });
    return this.extractData<Pesée[]>(response);
  }

  async getStatistiquesPesées(): Promise<ApiResponse<PeseeStatistiques>> {
    const response = await apiService.get('/weighing/api/pesees/statistiques/');
    return this.extractData<PeseeStatistiques>(response);
  }

  // Méthodes pour les nouvelles statistiques
  async getGeneralStats(filters?: any): Promise<ApiResponse<any>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/general_stats/', { params });
    return this.extractData<any>(response);
  }

  async getTimeSeriesData(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.period) params.append('period', filters.period);
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/time_series/', { params });
    return this.extractData<any[]>(response);
  }

  async getProductStats(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/product_stats/', { params });
    return this.extractData<any[]>(response);
  }

  async getClientStats(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/client_stats/', { params });
    return this.extractData<any[]>(response);
  }

  async getDriverStats(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/driver_stats/', { params });
    return this.extractData<any[]>(response);
  }

  async getVehicleStats(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/vehicle_stats/', { params });
    return this.extractData<any[]>(response);
  }

  async getSupplierStats(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/supplier_stats/', { params });
    return this.extractData<any[]>(response);
  }

  async getTransporterStats(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/transporter_stats/', { params });
    return this.extractData<any[]>(response);
  }

  async getExporterStats(filters?: any): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    
    const response = await apiService.get('/weighing/api/statistics/exporter_stats/', { params });
    return this.extractData<any[]>(response);
  }

  async generateCustomReport(reportConfig: any): Promise<ApiResponse<any>> {
    const response = await apiService.post('/weighing/api/statistics/custom_report/', reportConfig);
    return this.extractData<any>(response);
  }

  async getPredefinedReports(): Promise<ApiResponse<any[]>> {
    const response = await apiService.get('/weighing/api/statistics/predefined_reports/');
    return this.extractData<any[]>(response);
  }

  // Méthodes pour les tickets
  async getTickets(params?: any): Promise<ApiResponse<PaginatedResponse<Ticket>>> {
    const response = await apiService.get('/weighing/api/tickets/', { params });
    return this.extractData<PaginatedResponse<Ticket>>(response);
  }

  async getTicket(id: number): Promise<ApiResponse<Ticket>> {
    const response = await apiService.get(`/weighing/api/tickets/${id}/`);
    return this.extractData<Ticket>(response);
  }

  async createTicket(data: TicketCreate): Promise<ApiResponse<Ticket>> {
    const response = await apiService.post('/weighing/api/tickets/', data);
    return this.extractData<Ticket>(response);
  }

  async updateTicket(id: number, data: Partial<TicketCreate>): Promise<ApiResponse<Ticket>> {
    const response = await apiService.patch(`/weighing/api/tickets/${id}/`, data);
    return this.extractData<Ticket>(response);
  }

  async deleteTicket(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.delete(`/weighing/api/tickets/${id}/`);
    return this.extractData<void>(response);
  }

  // Actions spéciales pour les tickets
  async imprimerTicket(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.post(`/weighing/api/tickets/${id}/imprimer/`);
    return this.extractData<void>(response);
  }

  async exporterTicketPDF(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.post(`/weighing/api/tickets/${id}/exporter-pdf/`);
    return this.extractData<void>(response);
  }

  async envoyerTicketEmail(id: number): Promise<ApiResponse<void>> {
    const response = await apiService.post(`/weighing/api/tickets/${id}/envoyer-email/`);
    return this.extractData<void>(response);
  }

  // Fonction pour achever une pesée
  async completeWeighing(weighingId: number, finalObservations?: string, completeReason?: string): Promise<ApiResponse<Pesée>> {
    try {
      const response = await apiService.post(`/weighing/api/pesees/${weighingId}/marquer_completee/`, {
        observations: finalObservations || '',
        motif: completeReason || ''
      });
      return this.extractData<Pesée>(response);
    } catch (error) {
      console.error('Erreur lors de l\'achèvement de la pesée:', error);
      throw error;
    }
  }

  // Fonction pour archiver une pesée (utiliser la mise à jour du statut)
  async archiveWeighing(weighingId: number, archiveReason?: string): Promise<ApiResponse<Pesée>> {
    try {
      const response = await apiService.patch(`/weighing/api/pesees/${weighingId}/`, {
        statut: 'ACHEVEE',
        observations: archiveReason || ''
      });
      return this.extractData<Pesée>(response);
    } catch (error) {
      console.error('Erreur lors de l\'archivage de la pesée:', error);
      throw error;
    }
  }
}

// Instance singleton du service de pesée
const weighingService = new WeighingService();
export default weighingService;
 
